const snakeToCamel = (str: string): string => {
  const camelboi = str.replace(/([-_]\w)/g, (g) => g[1].toUpperCase())
  return camelboi
}

export const camelizeObject = (
  props: Record<string, any>
): Record<string, any> => {
  return Object.entries(props).reduce<Record<string, any>>(
    (acc, [key, value]) => {
      if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        value == null
      ) {
        acc[snakeToCamel(key)] = value
      } else {
        if (Array.isArray(value)) {
          acc[snakeToCamel(key)] = value.map((v) => camelizeObject(v))
          return acc
        }
        acc[snakeToCamel(key)] = camelizeObject(value as Record<string, any>)
      }
      return acc
    },
    {}
  )
}
